import baseDiscoverService from './base/baseDiscoverService.js';

const createAiDiscoverabilityAssessment = (payload, config) => {
    return baseDiscoverService.post("api/reports/full-assessment", payload, config);
};
const createFreeReport = (payload, config) => {
    return baseDiscoverService.post("api/reports/free-report", payload, config);
};
const createSubjectSpecificAssessment = (payload, config) => {
    return baseDiscoverService.post("api/reports", payload, config);
};
const getAiDiscoverabilityReport = (id, config) => {
    return baseDiscoverService.get(`api/reports/${id}`, config);
};
const getAiDiscoverabilityReports = (config) => {
    return baseDiscoverService.get(`api/reports`, config);
};
const getDiscoverSubjectTimeSeries = (subjectId, config) => {
    return baseDiscoverService.get(`api/subjects/${subjectId}/time-series`, config);
};
const getDiscoverSubjectTopSources = (subjectId, config) => {
    return baseDiscoverService.get(`api/subjects/${subjectId}/top-sources`, config);
};
const getDiscoverSubjectAreasOfConcern = (subjectId, config) => {
    return baseDiscoverService.get(`api/subjects/${subjectId}/areas-of-concern`, config);
};
const updateDiscoverOrganization = (organizationId, payload, config) => {
    return baseDiscoverService.put(`api/organizations/${organizationId}`, payload, config);
};
const updateDiscoverSubject = (subjectId, payload, config) => {
    return baseDiscoverService.put(`api/subjects/${subjectId}`, payload, config);
};
const createDiscoverSubject = (payload, config) => {
    return baseDiscoverService.post(`api/subjects`, payload, config);
};
const getDiscoverSubjects = (params, config) => {
    return baseDiscoverService.get(`api/subjects`, Object.assign(Object.assign({}, config), { params }));
};
const getDiscoverOrganizations = (config) => {
    return baseDiscoverService.get(`api/organizations`, config);
};
const createDiscoverOrganization = (payload, config) => {
    return baseDiscoverService.post(`api/organizations`, payload, config);
};
const deleteDiscoverSubject = (subjectId, config) => {
    return baseDiscoverService.delete(`api/subjects/${subjectId}`, config);
};
const deleteDiscoverOrganization = (organizationId, config) => {
    return baseDiscoverService.delete(`api/organizations/${organizationId}`, config);
};
const requestDemoAccess = (payload, config) => {
    return baseDiscoverService.post("api/demo/access", payload, config);
};
const getTopCompetitors = (subjectId, config) => {
    return baseDiscoverService.get(`api/subjects/${subjectId}/top-competitors`, config);
};
const getWhiskerDistribution = (subjectId, config) => {
    return baseDiscoverService.get(`api/subjects/${subjectId}/whisker-distribution`, config);
};

export { createAiDiscoverabilityAssessment, createDiscoverOrganization, createDiscoverSubject, createFreeReport, createSubjectSpecificAssessment, deleteDiscoverOrganization, deleteDiscoverSubject, getAiDiscoverabilityReport, getAiDiscoverabilityReports, getDiscoverOrganizations, getDiscoverSubjectAreasOfConcern, getDiscoverSubjectTimeSeries, getDiscoverSubjectTopSources, getDiscoverSubjects, getTopCompetitors, getWhiskerDistribution, requestDemoAccess, updateDiscoverOrganization, updateDiscoverSubject };
